<form [formGroup]="form" (ngSubmit)="next()" *transloco="let t" bgoScrollToInvalidOnSubmit>
  <div class="grid pb-32 lg:grid-cols-3">
    <div class="lg:col-span-2">
      <h1 class="heading-xl">
        {{ isDamageRequest ? t('createJobRequest.contact.damageHeader') : t('createJobRequest.contact.header') }}
      </h1>
      <div class="mt-xs text-md">{{ t('createJobRequest.contact.hint.content') }}</div>
    </div>
    <h3 class="mt-xl heading-md lg:col-span-2">{{ t('createJobRequest.contact.details') }}</h3>
    <div class="mt-md md:w-1/2 lg:col-span-2">
      <div class="space-y-sm">
        @for (item of salutations; track item) {
          <cft-radio
            [formControl]="contactControls.salutation"
            [value]="item.key"
            name="contactSalutation"
            class="block"
          >
            {{ t(item.valueTranslationKey) }}
          </cft-radio>
        }
        @if (isControlInvalid(contactControls.salutation)) {
          <div class="error">
            {{ t('createJobRequest.contact.salutationRequired') }}
          </div>
        }
      </div>
      <cft-form-field class="mt-md">
        <label for="firstName">{{ t('createJobRequest.contact.firstName') }}</label>
        <input type="text" id="firstName" [formControl]="contactControls.firstName" />
      </cft-form-field>
      <cft-form-field>
        <label for="lastName">{{ t('createJobRequest.contact.lastName') }}</label>
        <input type="text" id="lastName" [formControl]="contactControls.lastName" />
      </cft-form-field>
      <cft-form-field>
        <label for="companyName">{{ t('createJobRequest.contact.companyName') }}</label>
        <input type="text" id="companyName" [formControl]="contactControls.company" />
      </cft-form-field>
    </div>
    <h3 class="mt-lg heading-md lg:col-span-2">{{ t('createJobRequest.contact.contactDetails') }}</h3>
    <div class="mt-md md:w-1/2 lg:col-span-2">
      <cft-form-field>
        <label for="phoneNumber">{{ t('createJobRequest.contact.phoneNumber') }}</label>
        <input
          type="text"
          id="phoneNumber"
          [formControl]="contactControls.phoneNumber"
          bgoPrefix="+41"
          [prefixPreventChange]="false"
          inputmode="tel"
        />
        <span class="error">{{ t('createJobRequest.errors.invalidPhoneNumberFieldValidation') }}</span>
      </cft-form-field>
      <cft-form-field>
        <label for="email">{{ t('createJobRequest.contact.email') }}</label>
        <input type="text" id="email" [formControl]="contactControls.email" inputmode="email" bgoTrimValue />
        <span class="error">{{ t('createJobRequest.errors.invalidEmail') }}</span>
      </cft-form-field>
    </div>
    @if (offering?.executionAddressEnabled) {
      <div class="mt-lg md:w-1/2 lg:col-span-2">
        <cft-checkbox [formControl]="billingDetailsControls.controls.billingAddressNotIdentical | bgoAsFormControl">
          {{ t('createJobRequest.contact.billingAddressIdentical') }}
        </cft-checkbox>
      </div>
    }
    @if (billingAddressNotIdenticalControl.value) {
      <div class="mt-xl space-y-lg md:w-1/2 lg:col-span-3" data-testid="billingAddressFields">
        <div class="flex flex-col gap-lg">
          @if (
            (!offering?.executionAddressEnabled && billingClientNotIdenticalControl.value) ||
            offering?.executionAddressEnabled
          ) {
            <div class="order-2 space-y-md">
              <h3 class="heading-md">{{ t('createJobRequest.contact.billingDetails') }}</h3>
              <div class="space-y-sm">
                @for (item of salutations; track item) {
                  <cft-radio
                    [formControl]="billingClientControls.salutation"
                    name="billingSalutation"
                    [value]="item.key"
                    class="block"
                  >
                    {{ t(item.valueTranslationKey) }}
                  </cft-radio>
                }
                @if (isControlInvalid(billingClientControls.salutation)) {
                  <div class="error">
                    {{ t('createJobRequest.contact.salutationRequired') }}
                  </div>
                }
              </div>
              <cft-form-field class="mt-md">
                <label for="billingAddressFirstName">{{ t('createJobRequest.contact.firstName') }}</label>
                <input type="text" id="billingAddressFirstName" [formControl]="billingClientControls.firstName" />
              </cft-form-field>
              <cft-form-field>
                <label for="billingAddressLastName">{{ t('createJobRequest.contact.lastName') }}</label>
                <input type="text" id="billingAddressLastName" [formControl]="billingClientControls.lastName" />
              </cft-form-field>
              <cft-form-field>
                <label for="billingAddressCompanyName">{{ t('createJobRequest.contact.companyName') }}</label>
                <input type="text" id="billingAddressCompanyName" [formControl]="billingClientControls.company" />
              </cft-form-field>
            </div>
            <div class="order-3 space-y-md">
              <h3 class="heading-md">{{ t('createJobRequest.contact.billingContactDetails') }}</h3>
              <div class="md:w-full">
                <cft-form-field>
                  <label for="billingAddressPhoneNumber">{{ t('createJobRequest.contact.phoneNumber') }}</label>
                  <input
                    type="text"
                    id="billingAddressPhoneNumber"
                    [formControl]="billingClientControls.phoneNumber"
                    bgoPrefix="+41"
                    inputmode="tel"
                    [prefixPreventChange]="false"
                  />
                  <span class="error">{{ t('createJobRequest.errors.invalidPhoneNumberFieldValidation') }}</span>
                </cft-form-field>
                <cft-form-field>
                  <label for="billingAddressEmail">{{ t('createJobRequest.contact.email') }}</label>
                  <input
                    type="text"
                    id="billingAddressEmail"
                    [formControl]="billingClientControls.email"
                    inputmode="email"
                    bgoTrimValue
                  />
                  <span class="error">{{ t('createJobRequest.errors.invalidEmail') }}</span>
                </cft-form-field>
              </div>
            </div>
          }
          <div class="order-4 space-y-md" [class.order-1!]="!offering?.executionAddressEnabled">
            <h4 class="heading-md">{{ t('createJobRequest.contact.billingAddress') }}</h4>
            <div class="w-full">
              <cft-form-field>
                <label for="billingStreetHouseNumber">
                  {{ t('createJobRequest.contact.billingStreetHouseNumber') }}
                </label>
                <input
                  id="billingStreetHouseNumber"
                  type="text"
                  [formControl]="billingAddressControls.streetAndHouseNumber"
                />
              </cft-form-field>
              <cft-form-field>
                <label for="billingPostalCode">
                  {{ t('createJobRequest.contact.billingPostalCode') }}
                </label>
                <input
                  id="billingPostalCode"
                  type="number"
                  maxlength="4"
                  [formControl]="billingAddressControls.postalCode"
                />
              </cft-form-field>
              <cft-form-field>
                <label for="billingLocality">
                  {{ t('createJobRequest.contact.billingLocation') }}
                </label>
                <input id="billingLocality" type="text" [formControl]="billingAddressControls.locality" />
              </cft-form-field>
            </div>
            @if (!offering?.executionAddressEnabled) {
              <cft-checkbox [formControl]="billingClientNotIdenticalControl">
                {{ t('createJobRequest.contact.billingClientIdentical') }}
              </cft-checkbox>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <bgo-job-request-footer
    (cancelButtonClick)="processService.close(t('createJobRequest.close.closeButtonText'))"
    (backButtonClick)="previous()"
    [showBackButton]="true"
    [progressSteps]="progressSteps"
    [showPoweredByBuildigo]="!!agency?.logo"
  ></bgo-job-request-footer>
</form>
